import {Column} from '../../../../widgets/TablesComponents/AdvancedTable'
import {RegistroContactenos} from '../../../models/_models'

export const columnasContactenos: Column<RegistroContactenos>[] = [
  {
    key: 'IdContactenos',
    label: 'Id',
    type: 'number',
    className: 'min-w-50px  ps-4',
    id: true,
  },
  {
    key: 'Nombres',
    label: 'Nombres',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Apellidos',
    label: 'Apellidos',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Email',
    label: 'Email',
    type: 'string',
    className: 'min-w-200px',
  },
  {
    key: 'Celular',
    label: 'Celular',
    type: 'string',
    className: 'min-w-250px',
  },
  {
    key: 'Mensaje',
    label: 'Mensaje',
    type: 'string',
    className: 'min-w-350px',
  },

  {
    key: 'orgventas.Descripcion',
    label: 'Org Ventas',
    type: 'string',
    className: 'min-w-200px',
    render: (row) => row.orgventas?.Descripcion ?? '',
  },
  {
    key: 'estatus.Descripcion',
    label: 'Estatus',
    type: 'string',
    className: 'min-w-200px',
    render: (row) => row.estatus?.Descripcion ?? '',
  },

  {
    key: 'Activo',
    label: 'Activo',
    type: 'boolean',
    className: 'min-w-100px ps-4 ',
  },
  {key: 'CreadoPor', label: 'Creado Por', type: 'string', className: 'min-w-100px'},
  {key: 'CreadoEl', label: 'Creado El', type: 'date', className: 'min-w-150px'},
  {key: 'ModificadoPor', label: 'Modificado Por', type: 'string', className: 'min-w-150px'},
  {key: 'ModificadoEl', label: 'Modificado El', type: 'date', className: 'min-w-150px'},
]
